import { MyParadisePreferredPaymentModal } from "@app/modals/MyParadise/MyParadisePreferredPaymentModal/MyParadisePreferredPayment"
import { useGetStrings } from "@app/store/service/cmsService"
import { faTag } from "@fortawesome/free-solid-svg-icons/faTag"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useModal } from "@tecreation/funnel-components"
import "./MyParadisePreferredPayment.css"

export const MyParadisePreferredPayment = () => {
	const {
		data: { myParadiseOverviewPayment },
	} = useGetStrings(undefined, { defaultData: {} })
	const { showModal } = useModal()
	return (
		<div
			className="myParadisePreferedPayment h-100 color-bg-secondary-700 p-3 color-fg-white flex flex-column flex-center"
			onClick={() => {
				showModal(MyParadisePreferredPaymentModal)
			}}
		>
			<div className="flex flex-center f2">
				<FontAwesomeIcon icon={faTag} />
			</div>
			<div className="mt-3 text-center">{myParadiseOverviewPayment}</div>
		</div>
	)
}
